<template>
  <div class="uploadLeafletImg">
    <a class="upload-btn-text" @click="changeImg">修改照片</a>

    <el-dialog :title="dialogTitle" :visible.sync="showImgDialogVisible" width="30%">
      <input id="uploadLeafletImgInput" name="file" accept="image/*" type="file"
             @change="upData" style="display: none;" />
      <a @click="upImg" class="photoBox">
        <img :src="yqPicStr" id="uploadLeafletImg" v-if="yqPicStr" />
        <p style="margin-top: 50px;font-size: 36px;" v-if="!yqPicStr" >✚</p>
        <p v-if="!yqPicStr" style="margin-top: 20px">点击上传个人照片</p>
        <el-popover
          placement="bottom"
          width="120"
          class="personExample"
          trigger="hover">
          <img src="../../../assets/personExample.png" alt="" style="width: 120px;" >
          <div slot="reference" >照片示例</div>
        </el-popover>
      </a>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeShowImgDialogVisible" size="small">取 消</el-button>
        <el-button type="primary" @click="confirmUploadImg" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {api} from "../../../view/api/yqNotice"
import {nError} from "../../../utils/notice";
import {errorHandler} from "../../../utils/errorHandler";
import {getObjectURL} from "../../../utils/toBase64";

export default {
  name: "uploadLeafletImg",
  props: {
    dialogTitle: {
      type: String,
      default: '上传图片'
    },
  },
  data () {
    return {
      showImgDialogVisible: false,
      yqPicStr: '',
      yqPicUrl: ''
    }
  },
  methods: {
    // 展示修改图片
    changeImg () {
      this.showImgDialogVisible = true
      this.yqPicStr = ''
      this.yqPicUrl = ''
    },

    upImg () {
      $('#uploadLeafletImgInput')
        .click() // 隐藏了input:file样式后，点击头像就可以本地上传
        .on('change', function () {
          const objUrl = getObjectURL(this.files[0]) // 获取图片的路径，该路径不是图片在本地的路径
          if (objUrl) {
            $('#uploadLeafletImg').attr('src', objUrl) // 将图片路径存入src中，显示出图片
            window.sessionStorage.setItem('img', objUrl)
          }
        })
    },
    upData () {
      const that = this
      const oFReader = new FileReader()
      const file = document.getElementById('uploadLeafletImgInput').files[0]
      oFReader.readAsDataURL(file)
      oFReader.onloadend = function (oFRevent) {
        const src = oFRevent.target.result
        $('#uploadLeafletImg').attr('src', src)
        that.yqPicStr = src
      }
    },

    // 取消上传
    closeShowImgDialogVisible () {
      this.showImgDialogVisible = false
      this.yqPicStr = ''
      this.yqPicUrl = ''
    },

    // 确认上传
    confirmUploadImg () {
      if (!this.yqPicStr) {
        nError('请上传图片')
        return
      }
      this.$axios.post(api.commonUploadImg, {
        picData: this.yqPicStr,
        compressedSize: 90
      })
        .then(res => {
          this.yqPicUrl = res.data.data
          this.$emit('updateAuthorityImage', this.yqPicUrl)
          this.showImgDialogVisible = false
          this.yqPicStr = ''
          this.yqPicUrl = ''
        })
        .catch(errorHandler('图片上传失败'))
    },
  }
}
</script>

<style scoped lang="less">
.uploadLeafletImg {
  display: inline;
  .upload-btn-text {
    color: #1362FF;
  }
  .upload-btn-text:hover {
    color: #06b3ff;
  }
  .photoBox {
    display: block;
    width: 120px;
    height: 160px;
    border: 1px dashed #dcdfe6;
    border-radius: 5px;
    position: relative;
    margin: 0 auto;
  }
  .personExample {
    position: absolute;
    bottom: -30px;
    text-align: center;
    left: 0;
    right: 0;
    margin: 0 auto;
    color: #00a0e6;
    cursor: pointer;
  }
  .photoBox img {
    width: 100%;
    height: 100%;
  }
  .photoBox p {
    color: #999999;
    font-size: 12px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/img/uploadLeafletImg.vue